import { render } from "./vipClub-en.vue?vue&type=template&id=98ed62f8&scoped=true"
import script from "./vipClub-en.vue?vue&type=script&lang=js"
export * from "./vipClub-en.vue?vue&type=script&lang=js"

import "./vipClub-en.vue?vue&type=style&index=0&id=98ed62f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ed62f8"]])

export default __exports__